import { Icons } from "../../../../../icons/icons";
import {
  contactConfig,
  getContactWhatsAppLink,
} from "../../../../../config/contact.config";

export default function FooterContact({ mode = "all" }) {
  const whatsappHref = getContactWhatsAppLink(mode);
  const mapsHref = contactConfig.address.mapsSearch || "#";

  return (
    <div className="site-footer__col site-footer__contact-col">
      <h4>Atendimento</h4>
      <div className="site-footer__title-line" />

      <ul className="site-footer__contact-list">
        <li>
          <span className="site-footer__contact-icon">
            <Icons.FaWhatsapp />
          </span>

          <div>
            <small>WhatsApp</small>
            <a href={whatsappHref} target="_blank" rel="noreferrer">
              {contactConfig.whatsapp.display}
            </a>
          </div>

          <span className="site-footer__contact-arrow">›</span>
        </li>

        <li>
          <span className="site-footer__contact-icon">
            <Icons.Mail />
          </span>

          <div>
            <small>E-mail</small>
            <a href={contactConfig.email.href}>{contactConfig.email.value}</a>
          </div>

          <span className="site-footer__contact-arrow">›</span>
        </li>

        <li>
          <span className="site-footer__contact-icon">
            <Icons.FaInstagram />
          </span>

          <div>
            <small>Instagram</small>
            <a
              href={contactConfig.instagram.href}
              target="_blank"
              rel="noreferrer"
            >
              {contactConfig.instagram.handle}
            </a>
          </div>

          <span className="site-footer__contact-arrow">›</span>
        </li>

        <li>
          <span className="site-footer__contact-icon">
            <Icons.MapPin />
          </span>

          <div>
            <small>Endereço</small>
            <a href={mapsHref} target="_blank" rel="noreferrer">
              {contactConfig.address.full}
            </a>
          </div>

          <span className="site-footer__contact-arrow">›</span>
        </li>
      </ul>
    </div>
  );
}